import { useMutation } from '@tanstack/react-query';
import { axiosInstance, RequiredCreditsResponse } from '../../utils';

interface Payload {
  videoId?: string;
  duration?: number;
}

const getRequiredCredits = async (payload: Payload): Promise<RequiredCreditsResponse> => {
  const res = await axiosInstance.post('/api/video/required-credits', payload);

  return res.data;
};

export const useGetRequiredCredits = () => {
  return useMutation((payload: Payload) => getRequiredCredits(payload), { onSuccess: (data) => data });
};
